(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("userPreferencesManagerService", UserPreferencesManagerService);
    UserPreferencesManagerService.$inject = ['$state', 'hUser', 'brandServices', 'userPermissions', 'dashboardsPrerequisiteService'];

    function UserPreferencesManagerService($state, hUser, brandServices, userPermissions, dashboardsPrerequisiteService) {
        const self = this;
        const _emitter = JarEventEmitter.call(self);
        self.HOME_PAGE_PREFERENCE = {
            HALO_DASHBOARD: 'HALO_DASHBOARD',
            ORIGINAL: 'ORIGINAL',
            RISK_ANALYSIS: 'RISK_ANALYSIS',
            HARRI_ENGAGE: 'HARRI_ENGAGE',
        };

        self.EVENTS = {
            USER_PREFERENCE_NAVIGATION_UPDATED: 'user_preference_navigation_updated',
        };

        const [getUserPreferences, resetUserPreferencesCache] = cacheService.cache(UserPreferencesManagerAPI.getUserNavigationPreferences);


        self.getUserPreferences = getUserPreferences;

        /**
         * Retrieves user navigation preferences asynchronously.
         * @async
         * @function getUserNavigationPreferences
         * @returns {Promise<HALO_DASHBOARD | ORIGINAL>} A promise resolving to user navigation preferences default home page.
         * @throws {Error} If an error occurs during the retrieval process and retrieve original dashboard
         */
        const getUserNavigationPreferences = async () => {
            try {
                let userNavigationPreferences = {default_home_page: self.HOME_PAGE_PREFERENCE.ORIGINAL};

                const entryBrandId = hUser.getEntryMode().brand_id;
                const [
                    canViewHaloDashboard,
                    canViewRiskDashboard,
                    canViewSentimentEngagementDashboard
                ] = await Promise.all([
                    dashboardsPrerequisiteService.canViewHaloDashboard(entryBrandId),
                    dashboardsPrerequisiteService.canViewRiskDashboard(entryBrandId),
                    dashboardsPrerequisiteService.canViewSentimentEngagementDashboard(entryBrandId),
                ]);

                if (canViewHaloDashboard || canViewRiskDashboard || canViewSentimentEngagementDashboard) {
                    userNavigationPreferences = await getUserPreferences();
                }

                return userNavigationPreferences;
            } catch (err) {
                console.error(err);
                return {default_home_page: self.HOME_PAGE_PREFERENCE.ORIGINAL};
            }
        };

        /**
         * Retrieves the redirect state for the home page based on user preferences.
         * @async
         * @function getDashboardRoute
         * @memberof self
         * @returns {Promise<{name: string,href: string,isUrl: boolean,params: Object}>} A Promise resolving to the redirect state for the home page.
         */
        self.getDashboardRoute = async (redirectToHome) => {
            let params = {};
            let href;
            let isUrl = false;
            let redirectToWorkspace = false;
            let redirectToState;

            if (redirectToHome && hUser.isShadowUser()) {
                href = publicConfiguration.getCorporateHost();
                redirectToState = '';
                isUrl = true;
            } else if (hUser.isEmployer()) {
                const [
                    homePageUserPreferences,
                    isTTSDashboardEnabled,
                    policyParser,
                    canViewHaloDashboard,
                    canViewRiskDashboard,
                    canViewEmployeeVoiceDashboard
                ] = await Promise.all([
                    getUserNavigationPreferences(),
                    brandServices.check(brandServices.SERVICES.TTS_DASHBOARD, hUser.getUserContext().brand_id),
                    userPermissions.getBrandPolicy(hUser.getUserContext().brand_id),
                    dashboardsPrerequisiteService.canViewHaloDashboard(hUser.getUserContext().brand_id),
                    dashboardsPrerequisiteService.canViewRiskDashboard(hUser.getUserContext().brand_id),
                    dashboardsPrerequisiteService.canViewSentimentEngagementDashboard(hUser.getUserContext().brand_id)
                ]);

                if (canViewHaloDashboard && homePageUserPreferences.default_home_page === self.HOME_PAGE_PREFERENCE.HALO_DASHBOARD) {
                    if (hUser.isTopLevelContext() || (hUser.isHMAPUser() && redirectToHome)) {
                        redirectToState = 'appLayout.harriSH.dashboards.main-gp';
                    } else {
                        redirectToState = 'appLayout.harriSH.dashboards.main-parent';
                    }
                } else if (canViewRiskDashboard && homePageUserPreferences.default_home_page === self.HOME_PAGE_PREFERENCE.RISK_ANALYSIS) {
                    redirectToState = 'appLayout.harriSH.dashboards.risk';
                } else if (canViewEmployeeVoiceDashboard && homePageUserPreferences.default_home_page === self.HOME_PAGE_PREFERENCE.HARRI_ENGAGE) {
                    redirectToState = 'appLayout.harriSH.dashboards.sentiment-engagement';
                } else if (hUser.isTopLevelContext() || (redirectToHome && hUser.isHMAPUser())) {
                    redirectToState = 'appLayout.harriSH.access-portal.main';
                    params = {hmapPath: '', inherit: false};
                    redirectToWorkspace = true;
                } else if (policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM) && !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)) {
                    redirectToState = 'appLayout.schedule.main';
                } else if (isTTSDashboardEnabled) {
                    redirectToWorkspace = true;
                    redirectToState = 'appLayout.harriSH.dashboard-tts';
                } else {
                    redirectToState = 'appLayout.harriSH.dashboard-hiring';
                }

                if (hUser.isSubwayExternalAuth() && !HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'customWelcomePageShown'
                })) {
                    const ipcSubwayDashboardEndpoint = publicConfiguration.getIpcSubwayDashboardConfig();
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'customWelcomePageShown',
                        value: 'true',
                    });
                    href = ipcSubwayDashboardEndpoint;
                    redirectToState = '';
                    isUrl = true;
                }
            } else {
                redirectToState = 'dashboard-member';
            }

            if (redirectToState) {
                href = $state.href(redirectToState, params);
            }

            return {
                name: redirectToState,
                href: href,
                isUrl: isUrl,
                params: params,
                redirectToWorkspace
            };
        };

        self.resetUserPreferences = () => {
            resetUserPreferencesCache();
            _emitter.trigger(self.EVENTS.USER_PREFERENCE_NAVIGATION_UPDATED);
        };

    }
})();
